import React, {memo} from "react"
import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component"
import Header from "tabloom/build/header"

export default memo(shapeComponent(class CardTableHeader extends ShapeComponent {
  render() {
    const {style, ...restProps} = this.props

    return (
      <Header style={this.tt.styleCallback} {...restProps} />
    )
  }

  styleCallback = ({column, rowContext, style, tableContext}) => {
    const columnPosition = column.tt.position
    const rowPosition = rowContext.row.tt.position
    const columnsCount = tableContext.table.headersCount

    style.justifyContent = "center"

    style.backgroundColor = "#fff"
    style.padding = 15

    style.borderColor = "#e5dfff"
    style.borderStyle = "solid"
    style.borderBottomWidth = 1

    if (columnPosition == 0) {
      style.borderLeftWidth = 1
    }

    if (rowPosition == 0) {
      style.borderTopWidth = 1
    }

    if (columnPosition == 0 && rowPosition == 0) {
      style.borderTopLeftRadius = 8
    }

    if (columnPosition == columnsCount - 1 && rowPosition == 0) {
      style.borderTopRightRadius = 8
    }

    if (columnPosition == columnsCount - 1) {
      style.borderRightWidth = 1
    }

    if (this.props.style) {
      Object.assign(style, this.props.style)
    }
  }
}))
